import { IQuiz } from '@sdk/contracts';
import { Button, Flex, Modal } from 'antd';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useQuizDeletionModal } from '@/hooks/useQuizDeletionModal';
import { useActivityByQuiz, useMutateMyQuizzes } from '@/store';

type Props = {
  quiz: IQuiz;
  onDelete: () => void;
};

const MODAL_WIDTH = 400;

export const RemoveQuiz: React.FC<Props> = ({ quiz, onDelete }) => {
  const { t } = useTranslation(['ManagerQuizzesTranslations', 'DefaultTranslations']);
  const { isWorking } = useMutateMyQuizzes();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { setQuizId } = useQuizDeletionModal();
  const { activities, isWorking: isLoadingActivities } = useActivityByQuiz(quiz._id);

  const isButtonDisabled = isWorking || isLoadingActivities;

  return (
    <>
      <Button
        danger
        type="text"
        loading={isWorking}
        disabled={isButtonDisabled}
        onClick={e => {
          e.stopPropagation();
          if (activities?.length) {
            setQuizId(quiz._id);
            return;
          }

          setIsModalOpen(true);
        }}
        icon={<Icon i="TrashCan" />}>
        {t('DELETE_QUIZ')}
      </Button>

      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        okText={t('DELETE_QUIZ')}
        cancelText={t('DefaultTranslations:CANCEL')}
        onOk={onDelete}
        okButtonProps={{ loading: isButtonDisabled }}
        centered
        width={MODAL_WIDTH}
        title={t('ManagerQuizzesTranslations:DELETE_QUIZ_QUESTION')}
        wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}>
        <Flex vertical style={{ paddingTop: 16, paddingBottom: 16 }}>
          <span>
            <Trans
              i18nKey="ManagerQuizzesTranslations:DELETE_QUIZ_DESCRIPTION"
              values={{ name: quiz.title }}
              components={{ bold: <strong /> }}
            />
          </span>

          <span>{t('DefaultTranslations:THIS_ACTION_CANNOT_BE_UNDONE')}</span>
        </Flex>
      </Modal>
    </>
  );
};
